import { Endpoint } from "../../typings/endpoints";
import { Lecture } from "../../typings/Lecture";
import http from "../../utils/http";

function stringifyArray(array: string[]) {
  return array.length < 1 ? "" : array.toString();
}

const lecturesApi = {
  getLectures: async ({
    page,
    topicIds,
    areaIds,
    instructorIds,
    date,
  }: {
    page: number;
    topicIds: number[];
    areaIds: number[];
    instructorIds: number[];
    date: Nullable<string>;
  }): Promise<Lecture[]> => {
    const response = await http.get<Lecture[]>(
      `${Endpoint.LectureList}?page=${page}${
        topicIds.length
          ? `&topics=${stringifyArray(topicIds.join().split(","))}`
          : ""
      }${
        areaIds.length
          ? `&areas=${stringifyArray(areaIds.join().split(","))}`
          : ""
      }${
        instructorIds.length
          ? `&instructors=${stringifyArray(instructorIds.join().split(","))}`
          : ""
      }${date ? `&date=${date}` : ""}`
    );
    return response.data; 
  },

  createLecture: async (lectureData: Partial<Lecture>): Promise<Lecture> => {
    const response = await http.post<Lecture>(Endpoint.LectureCreate, lectureData);
    return response.data;
  },

  deleteLecture: async (lectureId: number): Promise<void> => {
    await http.delete(`${Endpoint.LectureDelete}${lectureId}/`);
  },
};

export default lecturesApi;
